import { createElement, memo } from "react";
import { useTranslation } from "../localization";
/**
 * Logical Discovery Create Character block. It resolves copy and the CTA
 * action; hosts inject a view that owns layout and platform primitives.
 */
const DiscoverCreateCharacterBlock = ({ view, onCreateCharacter }) => {
    const { t } = useTranslation();
    const viewProps = {
        title: t("discover:discover.createCharacter.title", { defaultValue: "Create your own character" }),
        description: t("discover:discover.createCharacter.description", {
            defaultValue: "Nothing catching your eye? Craft your own character, bring them to life, and join a community of creators.",
        }),
        ctaLabel: t("discover:discover.createCharacter.cta", { defaultValue: "Create Character" }),
        onPress: onCreateCharacter,
    };
    return createElement(view, viewProps);
};
export default memo(DiscoverCreateCharacterBlock);
